export const SUBCATEGORY_LIST_REQUEST = "SUBCATEGORY_LIST_REQUEST";
export const SUBCATEGORY_LIST_SUCCESS = "SUBCATEGORY_LIST_SUCCESS";
export const SUBCATEGORY_LIST_FAIL = "SUBCATEGORY_LIST_FAIL";
export const SUBCATEGORY_LIST_RESET = "SUBCATEGORY_LIST_RESET";

export const SUBCATEGORY_DETAILS_REQUEST = "SUBCATEGORY_DETAILS_REQUEST";
export const SUBCATEGORY_DETAILS_SUCCESS = "SUBCATEGORY_DETAILS_SUCCESS";
export const SUBCATEGORY_DETAILS_FAIL = "SUBCATEGORY_DETAILS_FAIL";
export const SUBCATEGORY_DETAILS_RESET = "SUBCATEGORY_DETAILS_RESET";

export const ADMIN_SUBCATEGORY_LIST_REQUEST = "ADMIN_SUBCATEGORY_LIST_REQUEST";
export const ADMIN_SUBCATEGORY_LIST_SUCCESS = "ADMIN_SUBCATEGORY_LIST_SUCCESS";
export const ADMIN_SUBCATEGORY_LIST_FAIL = "ADMIN_SUBCATEGORY_LIST_FAIL";
export const ADMIN_SUBCATEGORY_LIST_RESET = "ADMIN_SUBCATEGORY_LIST_RESET";

export const ADMIN_SUBCATEGORY_DETAILS_REQUEST =
  "ADMIN_SUBCATEGORY_DETAILS_REQUEST";
export const ADMIN_SUBCATEGORY_DETAILS_SUCCESS =
  "ADMIN_SUBCATEGORY_DETAILS_SUCCESS";
export const ADMIN_SUBCATEGORY_DETAILS_FAIL = "ADMIN_SUBCATEGORY_DETAILS_FAIL";
export const ADMIN_SUBCATEGORY_DETAILS_RESET =
  "ADMIN_SUBCATEGORY_DETAILS_RESET";

export const ADMIN_SUBCATEGORY_CREATE_REQUEST =
  "ADMIN_SUBCATEGORY_CREATE_REQUEST";
export const ADMIN_SUBCATEGORY_CREATE_SUCCESS =
  "ADMIN_SUBCATEGORY_CREATE_SUCCESS";
export const ADMIN_SUBCATEGORY_CREATE_FAIL = "ADMIN_SUBCATEGORY_CREATE_FAIL";
export const ADMIN_SUBCATEGORY_CREATE_RESET = "ADMIN_SUBCATEGORY_CREATE_RESET";

export const ADMIN_SUBCATEGORY_UPDATE_REQUEST =
  "ADMIN_SUBCATEGORY_UPDATE_REQUEST";
export const ADMIN_SUBCATEGORY_UPDATE_SUCCESS =
  "ADMIN_SUBCATEGORY_UPDATE_SUCCESS";
export const ADMIN_SUBCATEGORY_UPDATE_FAIL = "ADMIN_SUBCATEGORY_UPDATE_FAIL";
export const ADMIN_SUBCATEGORY_UPDATE_RESET = "ADMIN_SUBCATEGORY_UPDATE_RESET";

export const ADMIN_SUBCATEGORY_DELETE_REQUEST =
  "ADMIN_SUBCATEGORY_DELETE_REQUEST";
export const ADMIN_SUBCATEGORY_DELETE_SUCCESS =
  "ADMIN_SUBCATEGORY_DELETE_SUCCESS";
export const ADMIN_SUBCATEGORY_DELETE_FAIL = "ADMIN_SUBCATEGORY_DELETE_FAIL";
export const ADMIN_SUBCATEGORY_DELETE_RESET = "ADMIN_SUBCATEGORY_DELETE_RESET";

export const SUBCATEGORY_CLEAR_ERROR = "SUBCATEGORY_CLEAR_ERROR";
export const ADMIN_SUBCATEGORY_CLEAR_ERROR = "ADMIN_SUBCATEGORY_CLEAR_ERROR";
